import { ReactElement } from 'react';
import classnames from 'classnames';
import Highcharts from 'highcharts';

import Logo from './Logo';
import Menu from './Menu';

import styles from './Sidebar.module.scss';

interface IProps {
  isExpanded: boolean;
  patientId: string;
}

const Sidebar = ({ isExpanded, patientId }: IProps): ReactElement => {
  const onTransitionEnd = () => {
    Highcharts.charts.forEach(x => x?.reflow());
  };

  return (
    <div
      className={classnames(styles.sidebar, { [styles.expanded]: isExpanded })}
      onTransitionEnd={onTransitionEnd}
    >
      <div className={styles.inner}>
        <Logo isExpanded={isExpanded} />
        <Menu isExpanded={isExpanded} patientId={patientId} />
      </div>
    </div>
  );
};

export default Sidebar;
